module.exports = __webpack_public_path__ + "static/media/background_mobile1.f9c7dcae.png";